/**
 * App
 */

// React
import React, { FC, useState, useEffect } from 'react';

// Router
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Refree from './routes';
import handleError from './utils/handleError';
import { withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

// Components
import Auth from './components/Auth';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  IconButton,
} from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

// UI
import Root from './pages/root';
import GetChangeLogs from 'client-sdk/src/Repository/changeLogs-repository';
import ReactMarkdown from 'react-markdown';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import handleNotfication from './utils/handleNotfication.tsx';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      '& .MuiContainer-maxWidthXl': {
        maxWidth: '100%',
      },
    },
  })
);
const env = process.env.REACT_APP_ENVIROMENT;
const App: FC = (props: object) => {
  const classes = useStyles();
  const [openChangeLogModal, setOpenChangeLogModal] = useState(false);
  const [changeLogInfo, setChangeLogInfo] = useState([]);
  // const [serialPort, setSerialPort] = useState(null)

  const getChangesHandler = async (today: any, lastSeen: any) => {
    GetChangeLogs.getChangeLoge({
      from: lastSeen ? lastSeen : today,
      type: 'PARTNER',
    })
      .then(res => {
        setChangeLogInfo(res.data);
        if (res.data.length > 0) {
          setOpenChangeLogModal(true);
        }
        localStorage.setItem('lastSeen', today);
      })
      .catch(err => {
        handleError(err.response);
        setOpenChangeLogModal(false);
      });
  };
  useEffect(() => {
    const today = `${new Date().getFullYear()}-${(
      '0' +
      (new Date().getMonth() + 1)
    ).slice(-2)}-${('0' + new Date().getDate()).slice(-2)}`;

    const lastSeen = localStorage.getItem('lastSeen');
    const token = localStorage.getItem('token');

    if (lastSeen !== today && token !== '') {
      getChangesHandler(today, lastSeen);
    }
  }, []);

  const onClose = () => {
    setOpenChangeLogModal(false);
  };

  // const serialTest = async () => {
  //   if(serialPort) {
  //     const encoder = new TextEncoder();
  //     const writer = serialPort.writable.getWriter();
  //     await writer.write(encoder.encode("PING"));
  //     writer.releaseLock();
  //     const reader = serialPort.readable.getReader();
  //     const { value, done } = await reader.read();
  //     console.log(new TextDecoder().decode(value))
  //     reader.releaseLock();
  //     console.log(serialPort.readable)
  //   }
  // }

  // const sendData = async () => {
  //   const port = await navigator.serial.requestPort();
  //   await port.open({ baudRate: 115200 });
  //   setSerialPort(port)
  // }

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Root} />
        <Auth>
          <div className={classes.root}>
            <Refree />
          </div>
          <Dialog
            fullWidth
            open={openChangeLogModal}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton aria-label="close" onClick={onClose}>
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              لیست تغییرات نسخه جدید
            </DialogTitle>
            <DialogActions>
              {changeLogInfo.map(el => (
                <Grid container spacing={1}>
                  <Grid item xs={4} style={{ padding: '20px' }}>
                    {el.date}
                  </Grid>
                  <Grid item xs={8} style={{ padding: '20px' }}>
                    <ReactMarkdown parserOptions={{ commonmark: true }}>
                      {el.description}
                    </ReactMarkdown>
                  </Grid>
                </Grid>
              ))}
            </DialogActions>
          </Dialog>
          {env == "production" && <Helmet>
            <script type="text/javascript">
              {(function (c, l, a, r, i, t, y) { c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }; t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i; y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y); })(window, document, "clarity", "script", "fnbu71it3f")}
            </script>
          </Helmet>}
        </Auth>
      </Switch>
    </Router>
  );
};

export default App;
